import { useMemo, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { withTheme } from 'styled-components';
import {
  clearUpdateData,
  clearSerializedData,
  setSerializedData,
  setBillboardImages,
  setExportModel,
  setExportedModelData,
  setReinitializeCanvas,
} from 'store/actions/canvasActions';
import { addMessage, clearMessages } from 'store/actions/appActions';
import { ENVIRONMENTS } from './environments';
import Canvas from '@archvisioninc/canvas';
import _ from 'lodash';

const RusswoodCanvas = withTheme(props => {
  const { theme, previewURL } = props;

  const dispatch = useDispatch();
  const canvasStore = useSelector(state => state.canvas);
  const appStore = useSelector(state => state.app);
  const selectedTheme = appStore.theme;
  const messages = appStore.messages;
  const { defaultEnvironments } = ENVIRONMENTS;
  const reinitializeCanvas = canvasStore.reinitializeCanvas;
  const updateData = useMemo(() => canvasStore.updateData, [ canvasStore ]);
  const exportModel = useMemo(() => canvasStore.exportModel, [ canvasStore ]);
  const integrationOptions = { shadows: false, meshHighlighting: false };

  const cleanup = useCallback(() => {
    dispatch(clearUpdateData());
    dispatch(clearSerializedData());
    dispatch(clearMessages());
    dispatch(setExportedModelData(null));
    dispatch(setReinitializeCanvas(false));
    dispatch(setExportModel(false));
    dispatch(setBillboardImages([]));
  }, [ dispatch ]);

  useEffect(() => {
    return () => cleanup();
  }, [ cleanup ]);

  if (!previewURL) return null;

  return (
    <Canvas
      data-testid='russwoodCanvas'
      theme={theme}
      $selectedTheme={selectedTheme}
      integration={integrationOptions}
      notifications={messages}
      defaultEnvironments={defaultEnvironments}
      addNotification={(messages, clearExisting) => dispatch(addMessage([ ...messages ], clearExisting))}
      clearNotifications={() => dispatch(clearMessages())}
      clearUpdateData={() => dispatch(clearUpdateData())}
      file={null}
      guidURL={previewURL}
      updateData={updateData}
      reinitialize={reinitializeCanvas}

      toDownload={false}
      exportModel={exportModel}
      exportType='glb'
      setDownloadedModel={data => dispatch(setExportedModelData(data))}

      setSerializedData={data => {
        const cleanData = JSON.stringify(data);
        dispatch(clearSerializedData());
        dispatch(setSerializedData(cleanData));
      }}
      setBillboardImages={newArray => {
        if (!_.isEmpty(newArray)) {
          dispatch(setBillboardImages(newArray));
        }
      }}
      previewMode={true}
    />
  );
});

export { RusswoodCanvas };